<div class="modal-auth-header modal-guest-auth-header">Please sign in</div>

<span
    id="auth-close-btn"
    class="iapply-dialog-close-wrapper modal-auth-close-button modal-guest-auth-close-button"
    mat-dialog-close
    (click)="closeModal()">
    <mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
</span>

<mat-divider class="modal-auth-divider"></mat-divider>

<guest-auth-form (successEvent)="signInSuccess()" (errorEvent)="handleError()"></guest-auth-form>